import { FC } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';

import { DirectLoginForm, DirectLoginValues } from './DirectLoginForm';

import { useMutationLoginDirect } from '~hooks';
import { useLanguageContext } from '~providers';
import { CampusCardInstitution } from '~types';

export const DirectLoginFormWrapper: FC<{
  institution: CampusCardInstitution;
  onLinked: () => void;
}> = ({ institution, onLinked }) => {
  const { lt } = useLanguageContext();

  const { mutateAsync: loginDirect } = useMutationLoginDirect({
    onSuccessCallback: onLinked,
  });

  const validationSchema = yup.object({
    username: yup
      .string()
      .required(
        lt(
          'app.rentalPage.newStepThree.campusCard.invalidUsername',
          'Invalid username.',
        ),
      ),
    password: yup
      .string()
      .required(
        lt(
          'app.rentalPage.newStepThree.campusCard.invalidPassword',
          'Invalid password.',
        ),
      ),
  });

  return (
    <Formik<DirectLoginValues>
      initialValues={{ username: '', password: '' }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        await loginDirect({
          institutionUuid: institution.uuid,
          username: values.username,
          password: values.password,
        });
      }}
    >
      <DirectLoginForm />
    </Formik>
  );
};
